import React from 'react';
import { Icon } from '../Icon';
import { useAiSwitch } from '../automation/useAiSwitch';

/** How it's doing, while the AI is Watching or Off (spec §5.13). Hidden on an older backend. */
export const AutomationBanner: React.FC<{ canOpen: boolean; onOpen: () => void }> = () => {
  const aiSwitch = useAiSwitch(true);
  const mode = aiSwitch.status === 'ready' && aiSwitch.value ? aiSwitch.value.mode : null;
  if (mode !== 'watching' && mode !== 'off') return null;
  return (
    <div className="cur-callout cur-callout--info" role="status" style={{ marginBottom: 16 }}>
      <Icon name="info" size="sm" />
      <span className="cur-grow">
        {mode === 'watching' ? "The AI is watching, so it isn't handling emails. Its proposals are shown in Watching results below." : "The AI is off, so it isn't handling emails."}
      </span>
    </div>
  );
};
